import { useSelector } from 'react-redux';

export const useDirectoryName = () => {
  const name = useSelector((state) => state.personalProfile.organization?.name);

  return name ? `${name} Directory` : 'Business Directory';
};
